// @flow
import React from "react";

import type { ErrorsType } from "../types/UserFormType";
import { ErrorsTypeList } from "../types/UserFormType";
import ErrorIcon from "@material-ui/icons/Error";

type ErrorDisplayPropType = {
  errors: ErrorsType,
  form: string
};

export function setErrorMsg(
  errors: ErrorsType,
  errorType: string,
  errorMsg: string,
  isDelete: boolean = false
): ErrorsType {
  if (isDelete) {
    delete errors[errorType];
  } else {
    errors[errorType] = errorMsg;
  }
  return errors;
}

export const checkEmail = (
  errors: ErrorsType,
  email: string,
  field?: string
): * => {
  if (email.trim() !== "") {
    const re = /^\w+([-+_=\.]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;
    if (!re.test(email)) {
      errors = setErrorMsg(
        errors,
        field ? field : "email",
        "Email Format is NOT Correct."
      );
    } else {
      errors = setErrorMsg(errors, field ? field : "email", "", true);
    }
  }
  return errors;
};

export const checkPassword = (
  errors: ErrorsType,
  pw1: string,
  pw2: string
): * => {
  if (pw1 !== "" && pw2 !== "" && pw1 !== pw2) {
    errors = setErrorMsg(
      errors,
      "password",
      "New Password and Confirm Password don't match."
    );
  } else {
    errors = setErrorMsg(errors, "password", "", true);
  }
  return errors;
};

export const checkPhone = (
  errors: ErrorsType,
  phone: string,
  field?: string
): * => {
  if (phone.trim() !== "") {
    const real = phone.trim().replace(/ /g, "");
    if (real.length < 10) {
      errors = setErrorMsg(
        errors,
        field ? field : "phone",
        "Phone Format is NOT Correct."
      );
    } else {
      errors = setErrorMsg(errors, field ? field : "phone", "", true);
    }
  }
  return errors;
};

export const checkPositiveInteger = (
  errors: ErrorsType,
  val: string,
  field?: string
): * => {
  let check = false;
  if (!isNaN(val)) {
    if (Number.isInteger(parseInt(val))) {
      if (val > 0) {
        check = true;
      }
    }
  }

  if (!check) {
    errors = setErrorMsg(
      errors,
      field ? field : "facebase",
      (field ? field : "Facebase") + " ONLY accepts positive integer."
    );
  } else {
    errors = setErrorMsg(errors, field ? field : "facebase", "", true);
  }
  return errors;
};

export const ErrosDisplay = (props: ErrorDisplayPropType): * => {
  const errors = props.errors;
  let generalErrors = [];
  Object.keys(errors).forEach(function(key: string) {
    if (
      ErrorsTypeList.includes(key) &&
      ![
        "credentials",
        "attempts",
        "email",
        "attempts_exceeded",
        "confirmation_code"
      ].includes(key)
    ) {
      if (errors[key]) {
        generalErrors.push(
          <span key={"general_errors_" + key}>
            {errors[key]}
            <br />
          </span>
        );
      }
    }
  });

  if (Object.keys(errors).length > 0) {
    return (
      <div className="banner error">
        <div className="box">
          <ErrorIcon className="inherit-icon right-margin-5" />
          <span className="content">
            {errors.credentials && (
              <span>
                Your {props.form} credentials are invalid.
                <br />
              </span>
            )}
            {errors.attempts && (
              <span>
                Your number of {props.form} attempts has been exceeded. Please
                try again later.
                <br />
              </span>
            )}
            {errors.email && (
              <span>
                {errors.email === "uniqueness"
                  ? "The user email already exists. Please use a different user email."
                  : errors.email}
                <br />
              </span>
            )}
            {errors.attempts_exceeded && (
              <span>
                {
                  "You have tried to reset your password too many times. Please try again after some time."
                }
                <br />
              </span>
            )}
            {errors.confirmation_code && (
              <span>
                {errors.confirmation_code === "expired"
                  ? "The verification code that you have supplied has expired"
                  : "The verification code that you have supplied is invalid"}
                <br />
              </span>
            )}
            {generalErrors}
          </span>
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export function apiFailCallbackHandle(
  callback: Object,
  fieldName?: string
): ErrorsType {
  let errors: ErrorsType = {};
  if (typeof callback === "string") {
    if (fieldName) {
      errors[fieldName] = callback;
    } else {
      errors["form"] = callback;
    }
  } else if (typeof callback === "object" && callback.constructor === Array) {
    callback.map((row: { [key: string]: * }) => {
      if ("field" in row && "message" in row) {
        if (fieldName) {
          errors[fieldName] = row.message;
        } else if (ErrorsTypeList.includes(row.field)) {
          errors[row.field] = row.message;
        } else {
          errors["form"] = row.message;
        }
      } else if ("errorType" in row && "message" in row) {
        if (fieldName) {
          errors[fieldName] = row.message;
        } else if (ErrorsTypeList.includes(row.errorType)) {
          errors[row.errorType] = row.message;
        } else {
          errors["form"] = row.message;
        }
      } else if ("locations" in row && "message" in row) {
        if (fieldName) {
          errors[fieldName] = row.message;
        } else {
          errors["form"] = row.message;
        }
      } else {
        errors["form"] = JSON.stringify(row);
      }
    });
  } else if (
    typeof callback === "object" &&
    callback.constructor !== Array &&
    callback !== undefined &&
    callback !== null
  ) {
    //dictionary
    const keys = Object.keys(callback);
    if (keys.includes("field") && keys.includes("message")) {
      if (fieldName) {
        errors[fieldName] = callback.message;
      } else if (ErrorsTypeList.includes(callback.field)) {
        errors[callback.field] = callback.message;
      } else {
        errors["form"] = callback.message;
      }
    } else if (keys.includes("errorType") && keys.includes("message")) {
      if (fieldName) {
        errors[fieldName] = callback.message;
      } else if (ErrorsTypeList.includes(callback.errorType)) {
        errors[callback.errorType] = callback.message;
      } else {
        errors["form"] = callback.message;
      }
    } else if (keys.includes("locations") && keys.includes("message")) {
      if (fieldName) {
        errors[fieldName] = callback.message;
      } else {
        errors["form"] = callback.message;
      }
    } else {
      let str = "";
      for (let key in callback) {
        if (fieldName) {
          errors[fieldName] = callback[key];
        } else {
          str += callback[key];
        }
      }
      errors["form"] = str;
    }
  } else {
    errors["form"] = JSON.stringify(callback);
  }
  return errors;
}

export const WarningDisplay = (props: {
  warning: string,
  display: boolean
}): * => {
  if (props.display) {
    return (
      <div className="banner warning">
        <div className="box">
          <ErrorIcon className="inherit-icon right-margin-5" />
          <span className="content">{props.warning}</span>
        </div>
      </div>
    );
  } else {
    return null;
  }
};
